<template>
  <div class="container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <!-- <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width: 140px; display: inline-block"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
          <el-input
            v-model="name"
            placeholder="请输入账号名称"
            style="width: 210px; display: inline-block"
            clearable
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('addeditcompany')"
            v-hasPermi="['用户管理-公司账号管理', '新增']"
            >新增公司账号</el-button
          >
        </div>
      </div>
      <div class="content-bodys">
        <div class="bodys-tree" v-show="companyList.length > 1">
          <el-tree
            node-key="company_id"
            ref="treeList"
            :data="companyList"
            @node-click="nodeClick"
            :props="defaultProps"
            :highlight-current="true"
            accordion
          >
          </el-tree>
        </div>
        <div class="bodys-table">
          <el-table
            stripe
            :data="table.data"
            v-loading="loading"
            height="calc(100% - 100px)"
            :header-cell-style="{ background: '#eaeef6' }"
            ref="companyTables"
          >
            <el-table-column type="index" label="序号" align="center">
            </el-table-column>
            <el-table-column
              prop="company_name"
              label="公司名称"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="username" label="公司账号" align="center">
            </el-table-column>
            <el-table-column prop="name" label="负责人姓名" align="center">
            </el-table-column>
            <el-table-column prop="phone" label="联系方式" align="center">
            </el-table-column>
            <el-table-column prop="email" label="企业邮箱" align="center">
            </el-table-column>
            <el-table-column prop="role_name" label="账户角色" align="center">
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <div class="edit">
                  <span
                    class="btn read"
                    @click="readClick(scope.row)"
                    v-hasPermi="['用户管理-公司账号管理', '编辑']"
                    >修改</span
                  >
                  <span
                    class="btn read"
                    @click="deleteUserclick(scope.row.id)"
                    v-hasPermi="['用户管理-公司账号管理', '删除']"
                    >删除</span
                  >
                  <span
                    class="btn read"
                    @click="resetClick(scope.row.id)"
                    v-hasPermi="['用户管理-公司账号管理', '重置密码']"
                    >重置密码</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              layout="sizes,prev, pager, next"
              :current-page.sync="table.pageNum"
              :page-size="table.pageSize"
              :total="table.total"
              @current-change="currentChange"
              @size-change="handleSizeChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MessageBox } from 'element-ui';
import {
  getAccountList,
  resetAccount,
  delAccount,
  getCompanys,
} from '@/api/user';
let userInfo = JSON.parse(localStorage.getItem('user'));
export default {
  data() {
    return {
      form: {
        name: '',
        type: '',
      },
      loading: false,
      options: [{ id: '', name: '全部' }],
      table: {
        data: [],
        height: 100,
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
      defaultProps: {
        children: 'children',
        label: 'company_name',
        id: 'company_id',
      },
      companyList: [],
      name: '',
      belongCompany: '',
    };
  },
  mounted() {
    this.getCompanyData();
    // this.getTableData()
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
  },
  methods: {
    nodeClick(val) {
      if (val.company_id === this.belongCompany) {
        return;
      } else {
        this.belongCompany = val.company_id;
        this.getTableData();
      }
    },
    getCompanyData() {
      getCompanys().then((da) => {
        this.companyList = da.data;
        if (this.companyList.length > 0) {
          this.belongCompany = this.companyList[0].company_id;
          this.$nextTick(function() {
            this.$refs.treeList.setCurrentKey(this.belongCompany); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
          });

          this.getTableData();
        }
      });
    },
    //获取列表
    getTableData() {
      let params = {
        companyId: this.belongCompany,
        pageNum: this.table.pageNum,
        pageSize: this.table.pageSize,
        type: 1,
        username: this.name,
      };
      getAccountList(params).then((da) => {
        this.table.data = da.data.content;
        this.table.tatal = da.data.total;
      });
    },
    resetClick(id) {
      MessageBox.confirm('此操作将重置密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          resetAccount({ id }).then((da) => {
            if (da.code === 0) {
              this.$message.success('重置密码成功');
            }
          });
        })
        .catch(() => {});
    },
    deleteUserclick(id) {
      let that = this;
      MessageBox.confirm('此操作将删除用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delAccount({ id }).then((res) => {
            if (res.code === 0) {
              that.search();
              that.$message.success('删除成功!');
            }
          });
        })
        .catch((e) => {});
    },
    search() {
      this.table.pageNum = 1;
      this.getTableData();
    },
    currentChange() {
      this.getTableData();
    },
    handleSizeChange(e) {
      this.table.pageNum = 1;
      this.table.pageSize = e;
      this.getTableData();
    },
    readClick(val) {
      this.$router.push({ name: 'addEditCompany', query: val });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    // padding: 0 0;
    padding-bottom: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
    .content-bodys {
      display: flex;
      width: 100%;
      height: 100%;
      .bodys-tree {
       width: 20%;
        // margin-right: 20px;
      }
      .bodys-table {
        width: 80%;
      }
    }
  }
}
</style>
<style lang="less">
.equipment-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
}
</style>
